<div
  class="w-[min(20rem,calc(100vw-2rem))] overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">
  <div class="flex items-start gap-3 px-4 pt-4 pb-3">
    <span
      class="mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-xl bg-slate-50 text-slate-600"
      aria-hidden="true">
      <app-svg-icon src="assets/icons/list-box-outline.svg" [size]="18" />
    </span>

    <div class="min-w-0 flex-1">
      <div class="flex items-start justify-between gap-2">
        <div class="min-w-0">
          <p class="truncate text-sm font-semibold text-slate-950">
            {{ summaryLabel || 'Answer details' }}
          </p>
          <p class="mt-0.5 text-[11px] leading-4 text-slate-500">
            Submission · Answer details
          </p>
        </div>
        <span
          class="shrink-0 rounded-md bg-slate-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-600">
          Answers
        </span>
      </div>
    </div>
  </div>

  <div class="px-4 pb-4">
    <div class="max-h-64 overflow-y-auto overflow-hidden rounded-xl border border-slate-200">
      @for (section of sections; track $index; let last = $last) {
        <div
          class="px-3 py-2.5 text-xs"
          [class.border-b]="!last"
          [class.border-slate-100]="!last">
          <p class="font-medium text-slate-900 break-words">{{ section.title }}</p>
          @if (section.subtitle) {
            <p class="mt-1 text-slate-500 break-words">{{ section.subtitle }}</p>
          }
        </div>
      } @empty {
        <div class="px-3 py-3 text-xs text-slate-500">No details to show.</div>
      }
    </div>
  </div>
</div>
